import { sendCapability } from 'flow/transactions/account';
import { addKeyToAccount } from 'flow/transactions/account';
import React, { useState } from 'react';
import { Button, Modal, Form, ModalHeader, ModalBody, ModalFooter, FormGroup, InputGroup, InputGroupAddon, Input, InputGroupText, Label } from 'reactstrap';

function SendCapabilityModal({modal, toggle, args, capability}) {
    const [recipient, setRecipient] = useState('')
   

    const hndleSendCapabilitySubmit = async (event) => {
        event.preventDefault();
        await sendCapability(capability.pathObj, capability.name, recipient)
        toggle()
      }

  return (
    <div>

      <Modal isOpen={modal} toggle={toggle} {...args}>
        <ModalHeader toggle={toggle}>Send Capability</ModalHeader>
        <ModalBody>
        <div className="text-center text-bold mb-4">
              <small>Enter Recipient</small>
            </div>
            <Form role="form">

              <FormGroup>
                    <Label for="recipientaddr">
                      Recipient Address
                    </Label>
                    <Input
                    id="recipientaddr"
                    placeholder="recipient address"
                    type="text"
                    value={recipient}
                    onChange={(e) => setRecipient(e.target.value)}
                    />
                </FormGroup>


            </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={hndleSendCapabilitySubmit}>
            Send
          </Button>{' '}
          <Button color="secondary" onClick={toggle}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default SendCapabilityModal;